import Container from '@mui/material/Container';

interface Props {
    children: JSX.Element,
}

export const MyMainContent = ({ children }: Props) => {
    return (
        <Container maxWidth="xl" sx={{ mt: 12, mb: 4 }}>
            {children}
        </Container>
    )
}
